import { render, staticRenderFns } from "./wgMode.vue?vue&type=template&id=0215ce38&scoped=true&"
import script from "./wgMode.vue?vue&type=script&lang=js&"
export * from "./wgMode.vue?vue&type=script&lang=js&"
import style0 from "./wgMode.vue?vue&type=style&index=0&id=0215ce38&lang=scss&scoped=true&"
import style1 from "./wgMode.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0215ce38",
  null
  
)

export default component.exports